import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@learningblocks/shared-components/lib/Modal";

/**
 * Modal Window Component for  FullWidthCard
 */
export function CardModalWindow(props) {
  return props.isModalOpen ? (
    <Modal
      isOpen={props.isModalOpen}
      size="lg"
      contentLabel={props.modalTitle}
      close={props.setModalClose}
      closeButton={true}
    >
      {props.children}
    </Modal>
  ) : null;
}

CardModalWindow.propTypes = {
  /**
   * Child element to be displayed inside the Modal
   */
  children: PropTypes.element.isRequired,
  /**
   * Boolean varible controlling if the modal is open.
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Title string for the Modal.
   */
  modalTitle: PropTypes.string.isRequired,
  /**
   * Callback function to be executed on closing Modal window.
   */
  setModalClose: PropTypes.func.isRequired,
};
